import React, { useState } from 'react'

import { Link } from 'react-router-dom'
import { Icon, Modal } from 'antd'
import { FormattedMessage } from 'react-intl'
import rootHistory from '../../rootHistory'
import PkgStatus from '../PkgStatus'

import '../../styles/PackageItem.css'
import { PackageInfo, PackStatus, PackType, Sticker } from '../../types'
import { packageUploadStageList } from '../../layout/Upload'

const StickerImgUI = ({
  icon,
  thumbnail,
}: {
  icon: string
  thumbnail: string
}) => (
  <span className="carton-img-wapper">
    <img src={thumbnail} className="carton-img" alt="pack thumbnail" />
    <span className="carton-darkness" />
    <Icon
      style={{ fontSize: 34 }}
      type={icon ? icon : 'edit'}
      className="carton-hover-icon"
    />
  </span>
)
type IconTypeInPackage = {
  [key in PackStatus]: string
}
const iconTypeInPackage: IconTypeInPackage = {
  creating: 'edit',
  editing: 'edit',
  unapproved: 'edit',
  'under review': 'eye',
  approved: 'eye',
  'pre deleted': 'edit',
  deleted: 'eye',
  discontinue: 'eye',
}
type PkgItemProp = {
  packageInfo: PackageInfo
  setSelectedPackageId: React.Dispatch<React.SetStateAction<string | null>>
}

const PkgItem = ({ packageInfo, setSelectedPackageId }: PkgItemProp) => {
  const icon = iconTypeInPackage[packageInfo.status]
  // unapproved 이유를 보여줄 패키지 아이디
  const mainName = packageInfo.name.en
  const handleClickLink = () => {
    console.log(packageInfo.status)
    switch (packageInfo.status) {
      case 'approved':
        setSelectedPackageId(packageInfo.objectId)
        break
      case 'under review':
        setSelectedPackageId(packageInfo.objectId)
        break
      case 'creating':
        rootHistory.push(
          `/upload/package/${packageInfo.objectId}/${packageUploadStageList[1]}`,
        )
        break
      case 'editing':
        rootHistory.push(
          `/upload/package/${packageInfo.objectId}/${packageUploadStageList[1]}`,
        )
        break
      case 'unapproved':
        console.log(packageInfo.objectId)
        setSelectedPackageId(packageInfo.objectId)
        break
      case 'pre deleted':
        setSelectedPackageId(packageInfo.objectId)
        break
    }

    // console.log('click link')
  }
  // console.log(mainName)
  // console.log(packageInfo)
  return (
    <div className="carton-item">
      <div onClick={handleClickLink}>
        <StickerImgUI icon={icon} thumbnail={packageInfo.thumbnail.url} />
      </div>
      <div
        className="carton-name"
        style={
          packageInfo.status === 'discontinue'
            ? { filter: 'opacity(0.5)', textAlign: 'start' }
            : { textAlign: 'start' }
        }
      >
        {/* movingstatus 가 있는 경우에만 표시함 */}
        {packageInfo.movingStatus && (
          <>
            <div className={`pack-type-badge-${packageInfo.packType}`}>
              <FormattedMessage
                id={`Upload.PkgCreation.createPack.packType.${packageInfo.packType}`}
                defaultMessage="PLUS"
              />
            </div>
            <div
              style={{
                marginBottom: '8px',
                fontSize: '14px',
                lineHeight: '20px',
                color: 'rgba(0, 0, 0, 0.38)',
              }}
            >
              <FormattedMessage
                id={`Upload.movingStatus.${packageInfo.movingStatus}`}
                defaultMessage=" "
              />
            </div>
          </>
        )}
        <p className="pack-name">
          {mainName.length > 40
            ? mainName.substring(0, 40) + '...'
            : mainName && mainName}
        </p>
      </div>
      <div>
        <PkgStatus
          status={packageInfo.status}
          style={{ justifyContent: 'center' }}
          isMyPkg={true}
        />
      </div>
    </div>
  )
}

export default PkgItem
